import ComingSoon from "components/ComingSoon";
import React from "react";

const MySql = () => {
  return <ComingSoon />;
};

export default MySql;
